export interface LocaleService {
  get(): string;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocaleService = Symbol('LocaleService');
